import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  namespaced: true,
  state: {
    list: [],
    total: 0,
  },
  mutations: {
    updateField,
    SET_LOGS(state, payload) {
      state.list = payload.logs;
      state.total = payload.total;
    },
  },
  actions: {
    async getLogs({ commit }, obj) {
      const { data } = await axios.get(`${url}/logs`, {
        headers: { 'x-access-token': obj.token },
        params: {
          page: obj.page,
          limit: obj.limit,
          filter: obj.filter ? obj.filter : null,
        },
      });
      commit('SET_LOGS', data);
    },
  },
  getters: { getField },
};
